import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';
import {
  actUpdateAccountProfile,
  actRequestUpdateOtp,
  actShowOtpModal,
  actSetOtpErrorMessage,
  actVerifyUpdateOtp,
  actSetStatusCode,
} from 'actions/setting/account';
import { phoneNumberFormatter } from 'utils/formatter';
import OtpModalDialog from './OtpModalDialog';
import styles from './style.css';

const validate = values => {
  const errors = {};
  if (!values.fullName) {
    errors.fullName = 'This field is required';
  } else if (values.fullName.trim() === '') {
    errors.fullName = 'This field is required';
  }
  if (!values.phone) {
    errors.phone = 'This field is required';
  } else if (
    values.phone[0] !== '8' ||
    values.phone.length < 9 ||
    values.phone.length > 12
  ) {
    errors.phone = 'Enter a valid phone number';
  }
  if (!values.email) {
    errors.email = 'This field is required';
  }
  return errors;
};

class AccountForm extends React.Component {
  constructor(props) {
    super(props);
    if (props.accountData) {
      this.initializeForm();
    }
    this.state = {
      fullName: props.accountData.fullName,
      newPhone: '',
    };
  }

  initializeForm() {
    const { accountData } = this.props;
    const initData = {
      fullName: accountData.fullName,
      phone: accountData.phone ? phoneNumberFormatter(accountData.phone) : '',
      email: accountData.email,
    };
    this.props.initialize(initData);
  }

  handleAccountSubmit = ({ fullName, phone }) => {
    const { accountData } = this.props;
    if (accountData.phone) {
      if (accountData.phone.substr(3, accountData.phone.length) !== phone) {
        this.setState(
          {
            fullName,
            newPhone: `+62${phone}`,
            email: accountData.email,
            phone: `+62${phone}`,
          },
          () => {
            this.props.dispatch(
              actRequestUpdateOtp(this.state.newPhone, false)
            );
          }
        );
      } else {
        this.setState(
          {
            fullName,
            newPhone: '',
            email: accountData.email,
            phone: `+62${phone}`,
          },
          () => {
            this.submitAccountData();
          }
        );
      }
    } else {
      this.setState(
        {
          fullName,
          newPhone: `+62${phone}`,
          email: accountData.email,
          phone: '',
        },
        () => {
          this.props.dispatch(actRequestUpdateOtp(this.state.newPhone, false));
        }
      );
    }
  };

  submitAccountData = () => {
    const arrName = this.state.fullName.split(' ');
    let firstName = '';
    let lastName = '';
    for (let i = 0; i < arrName.length; i++) {
      if (i === 0) {
        firstName = arrName[i];
      } else {
        lastName += `${arrName[i]} `;
      }
    }
    if (lastName.length > 0)
      lastName = lastName.substring(0, lastName.length - 1);
    const values = {
      user: {
        first_name: firstName,
        last_name: lastName,
        full_name: this.state.fullName,
        phone: this.state.newPhone,
        userPhone: this.state.phone,
        email: this.state.email,
      },
    };
    this.props.dispatch(actUpdateAccountProfile({ values }));
  };

  handleResendOtp = phone => {
    this.props.dispatch(actRequestUpdateOtp(phone, true));
  };

  handleBackClick = () => {
    this.props.dispatch(actShowOtpModal(false));
    this.props.dispatch(actSetOtpErrorMessage(null));
  };

  handleOtpSubmit = code => {
    const { requestId } = this.props.otp;
    const data = {
      code,
      request_id: requestId,
    };
    this.props.dispatch(actSetStatusCode(null));
    this.props.dispatch(actVerifyUpdateOtp(data));
  };

  componentWillReceiveProps(newProps) {
    if (newProps.otp.statusCode !== this.props.otp.statusCode) {
      if (newProps.otp.statusCode === 0) {
        this.submitAccountData();
      }
    }
  }

  render() {
    const { handleSubmit, valid, onClickBack, otp } = this.props;

    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>
            EDIT PERSONAL DETAILS
          </div>
        </div>
        <form
          className="col-xs-12"
          onSubmit={handleSubmit(this.handleAccountSubmit)}
        >
          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                <div className={styles['input-label']}>
                  Name as shown on ID Card (KTP)
                </div>
                <Field
                  component={SettingField}
                  name="fullName"
                  autoCorrect="off"
                  maxLength="30"
                  autoCapitalize="off"
                  spellCheck="false"
                  showTextError
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                <div className={styles['input-label']}>Phone</div>
                <Field
                  component={PhoneNumberField}
                  name="phone"
                  type="tel"
                  showTextError
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                <div className={styles['input-label']}>Email</div>
                <Field
                  component={SettingField}
                  name="email"
                  readOnly
                  showTextError
                />
              </div>
            </div>
          </div>
          <div className={`row ${styles['pb-50']}`}>
            <div className="col-12 col-xs-6">
              <button
                type="button"
                className={`btn btn-default ${styles['width-100']} ${
                  styles['back-button']
                }`}
                onClick={onClickBack}
              >
                Back
              </button>
            </div>
            <div className="col-12 col-xs-6">
              <button
                type="submit"
                disabled={!valid}
                className={`btn btn-primary ${styles['width-100']}`}
              >
                Save
              </button>
            </div>
          </div>
        </form>
        <OtpModalDialog
          onShow={otp.showModal}
          onHide={this.handleBackClick}
          phone={this.state.newPhone}
          otpError={otp.errorMessage}
          setOtpError={actSetOtpErrorMessage}
          handleOtpAction={actShowOtpModal}
          handleResendOtp={this.handleResendOtp}
          handleOtpSubmit={this.handleOtpSubmit}
        />
      </div>
    );
  }
}

const mapForm = {
  form: 'accountForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate, // a unique identifier for this form
};

function mapStateToProps(state) {
  return {
    data: {
      moka: state.moka,
      subscriptionExpired: state.subscriptionExpired,
      profile: state.setting.account.profile,
      businessKyb: state.setting.account.business_kyb,
      kyb: state.setting.account.kyb,
    },
    otp: {
      showModal: state.setting.account.otp_modal,
      requestId: state.setting.account.otp_request_id,
      errorMessage: state.setting.account.otp_error_msg,
      statusCode: state.setting.account.otp_status_code,
    },
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(AccountForm));
